import type { JSONContent } from '@tiptap/core';

// Nodes that carry no meaning on their own — empty when they have no children.
// Any node type NOT in this set is treated as meaningful content
// (e.g. image, youtube, mathematics).
const EMPTY_WHEN_CHILDLESS = new Set([
  'doc',
  'paragraph',
  'heading',
  'blockquote',
  'bulletList',
  'orderedList',
  'listItem',
  'taskList',
  'taskItem',
  'table',
  'tableRow',
  'tableCell',
  'tableHeader',
  'codeBlock',
  'hardBreak',
  'emptyLine',
]);

export function isEmptyContent(node: JSONContent | null | undefined): boolean {
  if (!node) return true;
  if (node.type === 'text') return !node.text?.trim();
  if (node.text) return false;
  if (node.content && Array.isArray(node.content) && node.content.length > 0) {
    return node.content.every(isEmptyContent);
  }
  return !node.type || EMPTY_WHEN_CHILDLESS.has(node.type);
}
